import { render, staticRenderFns } from "./ParallelDialog.vue?vue&type=template&id=3e643d7e&scoped=true"
import script from "./ParallelDialog.vue?vue&type=script&lang=js"
export * from "./ParallelDialog.vue?vue&type=script&lang=js"
import style0 from "./ParallelDialog.vue?vue&type=style&index=0&id=3e643d7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e643d7e",
  null
  
)

export default component.exports